import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
import { CARD_SURFACE } from '../../lib/surface-styles.js';
/**
 * Stat tile (handoff, Organisms > Dashboard summary): one number, said plainly.
 *
 * The label is above the value rather than below it because a number with no
 * name is not worth reading, and a screen reader meets them in the same order
 * as an eye does.
 *
 * Proportional figures, not tabular. Equal-width digits are for numbers that
 * line up vertically — table rows, axis ticks — and at this size they make a
 * value like "121" read loose and gappy. Nothing is stacked under a tile for
 * the alignment to help.
 */
export function StatTile({ label, value, detail, className, children }) {
    return (_jsxs("div", { className: cn(CARD_SURFACE, 'flex flex-col gap-1 p-6', className), children: [_jsx("span", { className: "text-label font-semibold uppercase text-text-muted", children: label }), _jsx("span", { className: "text-h1 font-bold text-text", children: value }), detail ? _jsx("span", { className: "text-body-sm text-text-secondary", children: detail }) : null, children] }));
}
//# sourceMappingURL=StatTile.js.map